import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ApplicationService, ApplicationMode } from '../../../services/application.service';
import { UserService } from '../../../services/user.service';
import { IUserInfo } from '../../../interface';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {

  hide = true;
  username: string;
  password: string;
  ApplicationMode: ApplicationMode;
  otpCode = null;
  error = "";

  get continue(): boolean {
    return this.userService.continue;
  }

  get enterOtp(): string {
    return this.userService.enterOtp;
  }

  get result(): string {
    return this.userService.result;
  }

  get loginResponse(): any {
    return this.userService.loginResponse;
  }

  constructor(
    private http: HttpClient, 
    public applicationService: ApplicationService,
    public userService: UserService,
    public router: Router
  ) {

    this.userService.userInfo = null;
    let loginComponent = this;
    window.addEventListener("keydown", function (e) {
      if (!loginComponent.continue && (e.code == "Enter" || e.code == "NumpadEnter")) {
        debugger;
        loginComponent.login();
      }
    });
  }
  
  get userInfo(): IUserInfo {
    return this.userService.userInfo;
  }

  get allowRegister(): boolean {
    if (this.applicationService.applicationMode == ApplicationMode.Business) {
      return true;
    }
    return false;
  }

  ngOnInit() {

    this.applicationService.pageTitle = "Please Sign In";
    this.applicationService.profileText = "Let's Connect!";
    
    if (sessionStorage.getItem("avbobJWT")) {
      this.router.navigate(['/connect/home']);
    }
    
    let service = this;
    window.setTimeout(() => {
      debugger;
      service.username = $("#txtUsername").text();
      service.password = $("#txtPassword").text();
      if (service.username && service.password) {
        service.login();
      }
      else {
        window.setTimeout(() => {
          $("#loginForm").fadeIn();
        }, 1000);
      }
    }, 1000);
   
  }

  showTerms() {
    this.userService.accept = false;
  }

  login() {
    this.userService.login(this.applicationService, this.username, this.password, true);
  }

  newOtp() {
    this.userService.sendOTP(this.applicationService, this.username);
  }

  validateOTP() {
    this.error = "";
    this.http.get<any>(this.applicationService.apiServiceUrl + '/User/ValidateOtp?repNumber=' + this.username + "&otp=" + this.otpCode)
      .toPromise().then(response => {
        if (response.Result) {
          this.userService.enterOtp = "";
          sessionStorage.setItem("localOTP", "true");
          this.userService.loadProfile(this.applicationService, this.username);
        }
        else {
          this.error = response.Message;
        }
      });
  }

  get usertype(): string {
    if (this.applicationService.applicationMode == ApplicationMode.Business) {
      return 'number';
    }
    return 'text';
  } 

  get userHint(): string {
    if (this.applicationService.applicationMode == ApplicationMode.Business) {
      return 'Enter your representative number';
    }
    return 'Enter your username';
  }

}
